//
import { ModuleLayout } from '@/components/reusable_components/next'
import SlGroundSellerSaleCommissionList from '@/views/Sale/SlGroundSellerSaleCommission/SlGroundSellerSaleCommissionList'

//
export default {
  path: 'ground_seller_sale_report',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'sl-ground-seller-sale-commission-list',
      component: SlGroundSellerSaleCommissionList,
    },
  ],
  meta: {
    title: 'Reporte de vendedores en terreno'
  },
}
